<template>
  <div class="main__section">
    <h1 class="section__title">
      {{ $t('dialogs') }} -> {{ $t('dialogs') }} {{ $t('with') }} {{ $t('by-clients') }}
    </h1>
    <div class="main__body">
      <div class="chat-body">
        <div class="choose__dialog-client">
          <div class="choose__dialog-select-date" @click="toggleDatePicker">
            {{ $t('select-date') }}
          </div>
          <date-picker v-model="filter" :is-range="true" v-show="pickerShow"/>
          <div class="choose__dialog-date">
            {{ $t('today') }}
          </div>
          <div class="choose__dialog-chats">
            <div class="chats-item pointer" v-for="dialog in sortedChats" @click="openDialog(dialog)" :class="checkRead(dialog.infoLastMessage)">
              <div class="chats-item_header">
                <div class="chats-item_header-name" v-if="dialog.middlename || dialog.firstname">
                  {{ dialog.middlename }} {{ dialog.firstname }}
                  <img src="@/assets/social/telegram.svg" v-if="dialog.type == 1">
                  <img src="@/assets/social/viber.svg" v-else-if="dialog.type == 2">
                  <img src="@/assets/social/sms.svg" v-else-if="dialog.type == 3">
                  <img src="@/assets/social/email.svg" v-else-if="dialog.type == 4">
                </div>
                <div class="chats-item_header-name" v-else>
                  Нет данных
                  <img src="@/assets/social/telegram.svg" v-if="dialog.type == 1">
                  <img src="@/assets/social/viber.svg" v-else-if="dialog.type == 2">
                  <img src="@/assets/social/sms.svg" v-else-if="dialog.type == 3">
                  <img src="@/assets/social/email.svg" v-else-if="dialog.type == 4">
                </div>
                <!--
                <div class="chats-item_header-time" v-if="dialog.infoLastMessage.Boolean">
                  123
                  <span class="chats-item_header-status" v-if="dialog.infoLastMessage.split('/')[2] == 0">{{ $t('sent') }}</span>
                  <span class="chats-item_header-status" v-if="dialog.infoLastMessage.split('/')[2] == 1">{{ $t('accept') }}</span>
                  {{ dialog.infoLastMessage.split('/')[1].split(' ')[1].slice(0, -3) }}
                </div>
                !-->
              </div>
              <div class="chats-item_body" v-if="dialog.infoLastMessage !== null">
                <template v-if="dialog.infoLastMessage.split('/--/')[0] != '-'">{{ dialog.infoLastMessage.split('/--/')[0] }}</template>
                <template v-else>Фотография</template>
              </div>
              <div class="chats-item_body" v-else>
                {{ $t('no-messages-start-dialogs') }}
              </div>
            </div>
          </div>
        </div>
        <div class="view__chat-main">
          <div class="view__chat-header">
            <div class="header__client-name" v-if="this.selectedClient.nDialog">
              {{ this.selectedClient.middlename }} {{ this.selectedClient.firstname }}
              <img src="@/assets/social/telegram.svg" v-if="this.selectedClient.type == 1 ">
              <img src="@/assets/social/viber.svg" v-else-if="this.selectedClient.type == 2">
              <img src="@/assets/social/sms.svg" v-else-if="this.selectedClient.type == 3">
              <img src="@/assets/social/email.svg" v-else-if="this.selectedClient.type == 4">
            </div>
            <div class="header__client-name" v-else>
              {{ $t('select-client') }}
            </div>
            <!--
            <div class="header__manager-name">
              <span>Ответственный</span>
              <span>Илья Комунин</span>
            </div>
            !-->
          </div>
          <div class="view__chat-body" v-if="this.chat.length > 0 && this.selectedClient.nDialog" ref="chat-body">
            <div class="message" v-for="item in chat" :class="item.from == 0 ? 'from' : 'to'">
              <p v-if="item.message != '-'" v-html="item.message"></p>
              <img class="chat-image" v-if="item.photo" :src="'https://api.expansium.ru/img/attachment/image/' + item.photo">
            </div>
          </div>
          <div class="view__chat-body" v-else-if="this.chat.length == 0 && this.selectedClient.nDialog" ref="chat-body">
            <div class="unknown-message">
              {{ $t('no-messages-start-dialogs') }}
            </div>
          </div>
          <div class="view__chat-body" v-else-if="!this.selectedClient.nDialog" ref="chat-body">
            <div class="unknown-message">
              {{ $t('select-client-start-dialog') }}
            </div>
          </div>
          <div class="view__chat-footer">
            <div class="view__chat-footer-input">
              <input placeholder="Написать сообщение..." v-model="message" v-on:keyup.enter="sendMessage"/>
              <span class="error" v-if="errors.message">{{ errors.message[0] }}</span>
              <a class="import-file">
                <img src="@/assets/icon/import.svg">
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <loading :active.sync="isLoading"
             :can-cancel="true"
             :is-full-page="fullPage"></loading>
  </div>
</template>

<style scoped>
.vc-container{
  position: absolute;
  top: 40px;
}
</style>

<script>
import axios from 'axios'
import loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import DatePicker from 'v-calendar/lib/components/date-picker.umd'
export default {
  name: 'view-chat',
  data: function(){
    return{
      dialogs: [],
      filter: null,
      pickerShow: false,
      chat: [],
      selectedClient: [],
      message: '',
      errors: [],
      oldMessage: [],
      isLoading: false,
      fullPage: true
    }
  },
  created: function(){
    this.getClients();
  },
  computed: {
    sortedChats: function() {
      return this.dialogs.sort((a, b) => b.lastMessage - a.lastMessage );
    }
  },
  watch:{
    chat: function(){
      this.$nextTick(function() {
        if(this.selectedClient.nDialog){
          var chat = this.$refs["chat-body"];
          chat.scrollTop = chat.scrollHeight;
        }
      });
    }
  },
  mounted: function () {
    this.$nextTick(function () {
      window.setInterval(() => {
        this.uploadInformation();
      },5000);
    });
  },
  methods: {
    toggleDatePicker: function(){
      this.pickerShow = !this.pickerShow;
      this.getClients();
    },
    getClients: function(){
      var data = {
        filter: this.filter
      }
      axios.post('getListClientFromGroup', data).then(response => {
        var status = response.data.status;
        if(status){
          this.dialogs = response.data.clients;
          this.oldMessage = response.data.clients;
        }
      });
    },
    openDialog: function(selectClient){
      this.isLoading = true;
      this.selectedClient = selectClient;
      axios.post('getListDialog', this.selectedClient.nDialog).then(response => {
        var status = response.data.status;
        if(status){
          this.chat = response.data.dialog;
          this.getClients();
          this.isLoading = false;
        }
      });
    },
    sendMessage: function(){
      if(this.message){
        var data = {
          message: this.message,
          nDialog: this.selectedClient.nDialog,
          type: this.selectedClient.type,
        }
        axios.post('sendMessage', data).then(response => {
          var status = response.data.status;
          if(status){
            this.chat = response.data.dialog;
            this.getClients();
            this.message = '';
            if(response.data.message){
              this.$toast.info(response.data.message);
              this.selectedClient = [];
            }
          }
        });
      }
    },
    uploadInformation: function(){
      var data = {
        nDialog: this.selectedClient.nDialog ? this.selectedClient.nDialog : '',
        type: this.selectedClient.type ? this.selectedClient.type : '',
        filter: this.filter
      }
      axios.post('getChatsInformation', data).then(response => {
        var status = response.data.status;
        if(status){
          this.chat = response.data.dialog;
          this.dialogs = response.data.clients;
        }else{
          this.errors = response.data.errors;
        }
      });
    },
    checkRead: function(lastMsg){
      if(lastMsg !== null){
        return lastMsg.split('/--/')[2] == 0 ? 'read' : '';
      }else{
        return '';
      }
    },
  },
  components: {
    loading, DatePicker
  }
}
</script>